import StatusTags from "@/pages/onboarding/components/StatusTags/StatusTags";

const getStatusForOwnOrg = (status) => {
    switch (status) {
        case "APPROVED":
            return "ACTIVE";
        case "PENDING":
            return "PENDING";
        case "REJECTED":
            return "REJECTED";
        case "REVOKED":
            return "REVOKED";
        case "INACTIVE":
            return "INACTIVE";
        case "PENDING_YOUR_APPROVAL":
            return "PENDING_YOUR_APPROVAL";
        default:
            return null;
    }
}

const getStatusForOtherOrg = (status) => {
    switch (status) {
        case "APPROVED":
            return "APPROVED";
        case "PENDING":
            return "PENDING_YOUR_CONSENT";
        case "REJECTED":
            return "REJECTED";
        case "REVOKED":
            return "REVOKED";
        case "INACTIVE":
            return "INACTIVE";
        default:
            return null;
    }
}

export const renderStatus = (status, rowData, profile) => {
    const { dataOwnerOrgId } = rowData;
    if (profile?.organizationId === dataOwnerOrgId) {
        const displayStatus =
			rowData.initiater === "SERVICE_PROVIDER" && status === "PENDING"
				? "PENDING_YOUR_APPROVAL"
				: status;
        return <StatusTags status={getStatusForOwnOrg(displayStatus)} />
    }
    else {
        return <StatusTags status={getStatusForOtherOrg(status)} />
    }
}

export const renderCPStatus = (status, rowData, profile) => {
    const { serviceProviderOrgId } = rowData;
    if (profile?.organizationId === serviceProviderOrgId) {
        const displayStatus =
			rowData.initiater === "DATA_OWNER" && status === "PENDING"
				? "PENDING_YOUR_APPROVAL"
				: status;
        return <StatusTags status={getStatusForOwnOrg(displayStatus)} />
    }
    else {
        return <StatusTags status={getStatusForOtherOrg(status)} />
    }
}